import React, { useState, useEffect } from 'react';

const DEFAULTS = {
  temperature: 0.7,
  maxTokens: 1024,
};

const Settings = ({ initialTemperature, initialMaxTokens, onSave }) => {
  const [temperature, setTemperature] = useState(initialTemperature ?? DEFAULTS.temperature);
  const [maxTokens, setMaxTokens] = useState(initialMaxTokens ?? DEFAULTS.maxTokens);
  const [message, setMessage] = useState('');

  useEffect(() => {
    setTemperature(initialTemperature ?? DEFAULTS.temperature);
    setMaxTokens(initialMaxTokens ?? DEFAULTS.maxTokens);
  }, [initialTemperature, initialMaxTokens]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSave) onSave({ temperature, maxTokens });
    setMessage('Settings saved!');
    setTimeout(() => setMessage(''), 2000);
  };

  return (
    <div className="glass-card shadow-lg p-8 mb-8 rounded-2xl">
      <h2 className="text-xl font-bold text-primary mb-4 text-center">Gemini API Settings</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-6">
          <label className="block mb-2 font-medium">Temperature: <span className="font-mono">{temperature}</span></label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={temperature}
            onChange={e => setTemperature(Number(e.target.value))}
            className="w-full accent-blue-600"
          />
        </div>
        <div className="mb-6">
          <label className="block mb-2 font-medium">Max Tokens:</label>
          <input
            type="number"
            min="1"
            max="4096"
            value={maxTokens}
            onChange={e => setMaxTokens(Number(e.target.value))}
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>
        <button type="submit" className="w-full py-2 bg-primary text-white rounded font-semibold hover:bg-primary-dark transition">Save</button>
      </form>
      {message && <p className="text-green-600 mt-4 text-center">{message}</p>}
    </div>
  );
};

export default Settings; 